(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/extensions/ball-row-description.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/extensions/ball-row-description.js');
'use strict';

function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.extensions = svs.tur.ball.row.extensions || {};
class RowDescription extends svs.tur.Base {
  constructor(_ref) {
    let title = _ref.title,
      description = _ref.description,
      price = _ref.price,
      when = _ref.when,
      tv = _ref.tv,
      winInfo = _ref.winInfo;
    super({
      className: 'ball-row-description'
    });
    this.title = title;
    this.description = description;
    this.price = price;
    this.when = when;
    this.tv = tv;
    this.winInfo = winInfo;
    this.render();
  }
  render() {
    const descArr = ["<div class=\"ng-header-small f-medium\">".concat(this.title, "</div>")];
    if (this.description) descArr.push(this.description);
    if (this.price) descArr.push(this.price);
    if (this.when) descArr.push("".concat(this.tv ? svs.ui.icon.partials.icon({
      icon: 'tv'
    }) : '').concat(this.when));
    const joinWithComma = _ref2 => {
      let _ref3 = _toArray(_ref2),
        first = _ref3[0],
        rest = _arrayLikeToArray(_ref3).slice(1);
      return "".concat(first, " ").concat(rest.join(', '));
    };
    let str = joinWithComma(descArr);
    if (this.winInfo) {
      str += "<div class=\"ball-row-description-extra\">\n              ".concat(this.winInfo.map((str, index) => index ? "<br />+ ".concat(str) : str).join(''), "\n              </div>");
    }
    this.$el.innerHTML = str;
    return this.$el;
  }
}
svs.tur.ball.row.extensions.Description = RowDescription;

 })(window);